import { computed }         from 'mobx';
import SalesPrivateApiModel from '../../abstracts/SalesPrivateApiModel';

export default class ChargeableModeModel extends SalesPrivateApiModel {
	static get path(): string {
		return '/chargeable_modes/{?id}';
	}

	@computed
	public get label(): string {
		return this.get('label');
	}

	@computed
	public get reference(): string {
		return this.get('reference');
	}
}
